import { useTranslation } from 'react-i18next';
import React, { useContext } from 'react';
import './header.css';
import AuthContext from '../../context/Auth/AuthContext';
import { Link, useLocation } from 'react-router-dom'
import rapLogo from '../../assets/img/RAP_high_resolution_web_1.png'
function Header() {

  const { pathname } = useLocation();
  const { t } = useTranslation('common');
  const { get_currentInstitution, is_selected_institution, baseUrlLogoInstitutions, is_login } = useContext(AuthContext);
  return (
    <header>
      <div className="primary_header">
        <div className="container_logo">
          <a href="https://qpss.ilo.org/" id={t('header.img_class')} className="navbar-brand"></a>
          
          {/*In pages outside Login the logo does not redirect to Home*/}
          { is_login() ?
            <Link to="/">
              <img className="new_ilo_styles_logo" src={rapLogo} alt="rap logo" /> 
            </Link>
            :
            <img className="new_ilo_styles_logo" src={rapLogo} alt="rap logo" />
          }
          
        </div>

        {is_selected_institution() && pathname !== '/AuthInstitutions' ?
          <div className="container_institution_logo d-md-block d-none ">
            <Link className="qpss_title_link" to="/AuthInstitutions">
              <img className="inst_log" src={`${baseUrlLogoInstitutions}${get_currentInstitution().catInstitutionLogoFilename}`} alt={get_currentInstitution().catInstitutionCountryName} />
            </Link>
          </div> : null
        }

      </div>

    </header>
  );
}

export default Header;
